export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string
export const PUBLIC_APP_URL = (import.meta.env.VITE_PUBLIC_APP_URL as string) || window.location.origin
export const DEFAULT_TIMEZONE = (import.meta.env.VITE_DEFAULT_TIMEZONE as string) || 'Africa/Cairo'

export function companyPortalUrl(token: string): string {
  return `${PUBLIC_APP_URL.replace(/\/$/, '')}/company/${token}`
}

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // Surfaced in the UI too (see App.tsx ConfigError), this console warning
  // is here for local `npm run dev` before .env is filled in.
  // eslint-disable-next-line no-console
  console.warn('VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are not set. Copy .env.example to .env and fill them in.')
}
